// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-summary-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  cursor: auto;
  height: auto;
  width: 288px;
}
.cart-summary-wrapper .ant-divider-horizontal {
  margin: var(--spacing-extra-small) 0;
}
.cart-summary-wrapper .cart-summary-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.cart-summary-wrapper .cart-summary-items {
  margin-top: var(--spacing-small);
}
.cart-summary-wrapper .cart-summary-items .vert-paragraph {
  font-size: var(--font-paragraph);
  cursor: auto;
}
.cart-summary-wrapper .cart-summary-items .vert-paragraph.label {
  font-weight: 400;
  line-height: 20px;
}
.cart-summary-wrapper .cart-summary-shipping {
  margin-bottom: var(--spacing-small);
}
.cart-summary-wrapper .cart-summary-shipping .vert-paragraph {
  font-size: var(--font-paragraph);
  cursor: auto;
}
.cart-summary-wrapper .cart-summary-shipping .vert-paragraph.label {
  font-weight: 400;
  line-height: 20px;
}
.cart-summary-wrapper .cart-summary-shipping .vert-paragraph.isFree {
  color: var(--color-highlight);
  font-weight: 500;
}
.cart-summary-wrapper .cart-summary-total {
  margin: var(--spacing-small) 0;
}
.cart-summary-wrapper .cart-summary-total .vert-paragraph {
  font-size: var(--font-paragraph);
  cursor: auto;
}
.cart-summary-wrapper .cart-summary-total .vert-paragraph.label {
  font-weight: 400;
  line-height: 20px;
}
.cart-summary-wrapper .cart-summary-button .vert-button {
  width: 100%;
}
.cart-summary-wrapper .divider {
  height: 1px;
  background-color: #EAEAEA;
  margin: var(--spacing-extra-small) 0;
}
.cart-summary-wrapper .change-address-link {
  font-size: var(--font-paragraph);
  font-weight: 500;
  color: var(--color-detached);
  text-decoration: underline;
  transition: color 0.2s ease-in-out;
}
.cart-summary-wrapper .change-address-link:hover {
  color: var(--color-highlight-darker);
}
@media screen and (max-width: 768px) {
  .cart-summary-wrapper {
    display: flex;
    flex-direction: column;
    border: 0;
    box-shadow: none;
    padding: 0;
    margin-bottom: var(--spacing-regular);
    width: 100%;
  }
  .cart-summary-wrapper::before {
    content: '';
    height: 1px;
    background-color: #EAEAEA;
    margin: var(--spacing-regular) 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Cart/CartSummaryStyles.less"],"names":[],"mappings":"AACA;EACI,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAAJ;AANA;EASQ,oCAAA;AAAR;AATA;EAcY,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAFZ;AAjBA;EAwBQ,gCAAA;AAJR;AApBA;EA2BY,gCAAA;EACA,YAAA;AAJZ;AAMY;EACI,gBAAA;EACA,iBAAA;AAJhB;AA5BA;EAsCQ,mCAAA;AAPR;AA/BA;EAyCY,gCAAA;EACA,YAAA;AAPZ;AASY;EACI,gBAAA;EACA,iBAAA;AAPhB;AAUY;EACI,6BAAA;EACA,gBAAA;AARhB;AA3CA;EAyDQ,8BAAA;AAXR;AA9CA;EA4DY,gCAAA;EACA,YAAA;AAXZ;AAaY;EACI,gBAAA;EACA,iBAAA;AAXhB;AAtDA;EAwEY,WAAA;AAfZ;AAzDA;EA6EQ,WAAA;EACA,yBAAA;EACA,oCAAA;AAjBR;AA9DA;EAmFQ,gCAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,kCAAA;AAlBR;AAoBQ;EACI,oCAAA;AAlBZ;AAwBA;EACI;IACI,aAAA;IACA,sBAAA;IAEA,SAAA;IACA,gBAAA;IACA,UAAA;IACA,qCAAA;IACA,WAAA;EAvBN;EAyBM;IACI,WAAA;IACA,WAAA;IACA,yBAAA;IACA,gCAAA;EAvBV;AACF","sourcesContent":["// DESKTOP\n.cart-summary-wrapper {\n    padding: var(--spacing-regular);\n    border-radius: var(--border-radius-secondary) !important;\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n    cursor: auto;\n    height: auto;\n    width: 288px;\n\n    .ant-divider-horizontal{\n        margin: var(--spacing-extra-small) 0;\n    }\n\n    .cart-summary-title {\n        .vert-title {\n            font-size: var(--font-medium);\n            font-weight: 600;\n            line-height: 24px !important;\n            margin: 0;\n            text-align: left;\n            cursor: auto;\n        }\n    }\n\n    .cart-summary-items {\n        margin-top: var(--spacing-small);\n\n        .vert-paragraph {\n            font-size: var(--font-paragraph);\n            cursor: auto;\n\n            &.label {\n                font-weight: 400;\n                line-height: 20px;\n            }\n        }\n    }\n\n    .cart-summary-shipping {\n        margin-bottom: var(--spacing-small);\n\n        .vert-paragraph {\n            font-size: var(--font-paragraph);\n            cursor: auto;\n\n            &.label {\n                font-weight: 400;\n                line-height: 20px;\n            }\n\n            &.isFree {\n                color: var(--color-highlight);\n                font-weight: 500;\n            }\n        }\n    }\n\n    .cart-summary-total {\n        margin: var(--spacing-small) 0;\n\n        .vert-paragraph {\n            font-size: var(--font-paragraph);\n            cursor: auto;\n\n            &.label {\n                font-weight: 400;\n                line-height: 20px;\n            }\n        }\n    }\n\n    .cart-summary-button {\n        .vert-button {\n            width: 100%;\n        }\n    }\n\n    .divider {\n        height: 1px;\n        background-color: #EAEAEA;\n        margin: var(--spacing-extra-small) 0;\n    }\n\n    .change-address-link {\n        font-size: var(--font-paragraph);\n        font-weight: 500;\n        color: var(--color-detached);\n        text-decoration: underline;\n        transition: color 0.2s ease-in-out;\n\n        &:hover {\n            color: var(--color-highlight-darker);\n        }\n    }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n    .cart-summary-wrapper {\n        display: flex;\n        flex-direction: column;\n\n        border: 0;\n        box-shadow: none;\n        padding: 0;\n        margin-bottom: var(--spacing-regular);\n        width: 100%;\n\n        &::before {\n            content: '';\n            height: 1px;\n            background-color: #EAEAEA;\n            margin: var(--spacing-regular) 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
